import { render } from "./LoadingView.vue?vue&type=template&id=2c03b89d&scoped=true"
import script from "./LoadingView.vue?vue&type=script&lang=js"
export * from "./LoadingView.vue?vue&type=script&lang=js"

import "./LoadingView.vue?vue&type=style&index=0&id=2c03b89d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c03b89d"]])

export default __exports__